<template>
  <div id="ticket-setting">
    <div class="vx-breadcrumb mb-4">
      <ul class="flex flex-wrap items-center">
          <li class="inline-flex items-end">
              <router-link to="/after-login"><feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" /></router-link>
              <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
          </li>
          <li class="inline-flex items-end">
              <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Ticket Template</span>
          </li>
      </ul>
  </div>
    <div class="w-full flex mb-6">
      <div class="w-1/2 pr-1 position-relative">
        <vs-button class="w-full ticket-type-btn" :class="{'active-btn': active_type == 'pos_receipt'}" @click="changeTypeData('pos_receipt')">Owner</vs-button>
        <div class="active-template-checkbox">
          <!-- <vs-checkbox color="white" class="text-primary" v-model="active_owner_template"></vs-checkbox> -->
          <div class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default">
            <span class="con-slot-label">
              <div class="title ml-auto"></div>
            </span>
            <input type="checkbox" class="vs-checkbox--input" v-model="active_owner_template" :value="active_owner_template" @change="onChange('pos_receipt')">
            <span class="checkbox_x vs-checkbox ml-auto">
              <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
            </span>

          </div>
        </div>
      </div>
      <div class="w-1/2 position-relative">
        <vs-button class="w-full ticket-type-btn" :class="{'active-btn': active_type == 'pos_receipt_customer'}" @click="changeTypeData('pos_receipt_customer')">Customer</vs-button>
        <div class="active-template-checkbox">
          <!-- <vs-checkbox color="white" class="text-primary" v-model="active_customer_template"></vs-checkbox> -->
          <div class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default">
            <span class="con-slot-label">
              <div class="title ml-auto"></div>
            </span>
            <input type="checkbox" class="vs-checkbox--input" v-model="active_customer_template" :value="active_customer_template" @change="onChange('pos_receipt_customer')">
            <span class="checkbox_x vs-checkbox ml-auto">
              <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
            </span>

          </div>
        </div>
      </div>
    </div>
    <div class="flex align-center flex-col">
      <!-- <div class="flex align-center w-full justify-start mb-5">
        <vs-switch v-model="active_template" class="mr-4"></vs-switch>
        <span v-if="active_template">Inactive this template</span>
        <span v-else>Active this template</span>
      </div> -->
      <!-- <vs-button class="px-4" @click="active_template = false" v-if="active_template">Inactive this template</vs-button> -->
      <div class="flex w-full position-relative" 
        :class="{'p-4': (active_type == 'pos_receipt' && !active_owner_template) || (active_type == 'pos_receipt_customer' && !active_customer_template)}"
      >
      <!-- <div class="flex w-full position-relative"> -->
        <div class="w-7/12 pr-5">
          <h4 class="text-lg font-bold text-title mt-3 mb-6 pb-2">Ticket Template</h4>
          <vx-card class="w-full my-4 shadow-md" v-for="(ticket, index) in ticketList.items" :key="index">
              <div class="flex justify-between align-center">
                  <div class="break-word" v-if="ticket.subject != 'custom_text'">{{index + 1}}. {{ticket.name}}</div>
                  <div class="break-word cursor-pointer" v-else>{{index + 1}}. <u @click="updateTicket(ticket)">{{ticket.content}}</u></div>
                  <div class="flex align-center" style="min-width: 100px;">
                      <feather-icon icon="ArrowUpIcon" svgClasses="w-5 stroke-current ml-4 cursor-pointer icon-group" @click="upTicket(ticket)"/>
                      <feather-icon icon="ArrowDownIcon" svgClasses="w-5 stroke-current ml-4 cursor-pointer icon-group" @click="downTicket(ticket)"/>
                      <img src="../../assets/images/trash-icon.png" class="ml-5 cursor-pointer trash-icon" @click.stop="deleteTicket(ticket)" />
                  </div>
              </div>
          </vx-card>

          <vx-card class="w-full my-4 shadow-md plus-card cursor-pointer" @click="popupAddActive = true">
            <div class="flex justify-center align-center">
              <feather-icon icon="PlusIcon" svgClasses="w-8 stroke-current ml-4 icon-plus"/>
            </div>
          </vx-card>
          <vs-popup class="holamundo create-block-ticket-popup" title="Create new block" :active.sync="popupAddActive">
            <div>
              <div>
                <label>Block Name</label>
                <v-select class="mb-4" v-model="select" label="name" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" :clearable="false" :searchable="false"/>
                <label>Param (Optional)</label>
                <vs-input v-model="content" class="w-full"/>
              </div>
              <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                  <vs-button class="mr-6 align-center save-responsive" @click="addTicket">Save</vs-button>
                  <vs-button class="cancel-responsive" type="border" color="danger" @click="popupAddActive=false">Cancel</vs-button>
              </div>
            </div>
          </vs-popup>
        </div>
        <div class="w-5/12 pl-5">
          <div class="flex align-center justify-between">
            <h4 class="text-lg font-bold text-title">Ticket Preview</h4>
            <vs-button class="px-4" @click="popupSetDefault = true">Restore default</vs-button>
          </div>
          <vx-card class="w-full my-4 shadow-md">
          <div v-html="ticketList.template_text"></div>
          </vx-card>
        </div>
        <div class="flex-center align-start" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.3)"
          v-if="(active_type == 'pos_receipt' && !active_owner_template) || (active_type == 'pos_receipt_customer' && !active_customer_template)">
          <!-- <vs-button class="mt-4 px-4" @click="active_template = true" v-if="!active_template">Active this template</vs-button> -->
        </div>
      </div>
      <vs-popup class="holamundo update-ticket-popup" title="Update ticket template" :active.sync="popupUpdateActive">
        <div>
          <div>
            <label>Block Name</label>
            <v-select class="mb-4" v-model="selected" label="name" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" :clearable="false" :searchable="false" :key="key_selected"/>
            <label>Param (Optional)</label>
            <vs-input v-model="param" class="w-full"/>
          </div>
          <div class="flex flex-wrap justify-center align-center p-6 mt-6">
              <vs-button class="mr-6 align-center save-responsive" @click="submitUpdate">Save</vs-button>
              <vs-button class="cancel-responsive" type="border" color="danger" @click="popupUpdateActive = false">Cancel</vs-button>
          </div>
        </div>
      </vs-popup>

      <vs-popup class="holamundo delete-group delete-popup" title="Restore Default Template" :active.sync="popupSetDefault">
          <div class="text-center">
              <h3>Do you want to restore default for this template?</h3>
              <div class="flex flex-wrap justify-center align-center p-6 mt-6">
              <vs-button class="mr-6 align-center delete-responsive" @click="setDefaultTemplate">Ok</vs-button>
              <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="popupSetDefault = false">Cancel</vs-button>
              </div>
          </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'vs-ticket-setting',
  data(){
    return{
        popupAddActive: false,
        popupUpdateActive: false,
        // customerText: [],
        //   options: [],
        select: {subject:'business_name', name: 'Business Name'},
        content: '',
        selected: {},
        param: '',
        key_selected: 0,
        ticket_id: '',
        action_type: '',
        isOpenLoading: false,
        loaded_data_num: 0,
        popupDeleteActive: false,
        popupSetDefault: false,
        options: [
            { name: "Business Name", subject: "business_name" },
            { name: "Store Phone", subject: "business_phone" }, // -> no co
            { name: "Store Address", subject: "business_address" }, // -> no co
            { name: "Customer Name", subject: "name" },
            { name: "Check-In Time", subject: "checkin" },
            { name: "Current Point", subject: "point" },
            { name: "Visit Time", subject: "visit" },
            // { name: "Services Selected", subject: "selected_service" },

            { name: "Staff", subject: "staff" }, // -> ta co
            // { name: "List service", subject: "list_service" }, // -> ta co
            { name: "Tip", subject: "tip" },
            { name: "Total Tip", subject: "total_tip" }, // -> no co
            { name: "Order ID", subject: "order_id" },
            { name: "Checkin ID", subject: "checkin_id" },
            { name: "Custom Text", subject: "custom_text" },
            { name: "New Line", subject: "new_line" },
            { name: "Customer Phone", subject: "phone" },
            { name: "Autocut", subject: "cut" },
            { name: "Line Separator", subject: "line_seperator" },
            
            { name: "Order Item", subject: "order_item" }, // -> ta co
            { name: "Card Info", subject: "credit_info" },
            { name: "Sub-total", subject: "sub_total" },
            { name: "Total", subject: "total" },
            { name: "Signature", subject: "signature" },
            { name: "Tip Suggesstion", subject: "tip_suggestion"}
        ],
        active_type: 'pos_receipt',
        show_layout: true,
        active_owner_template: true,
        active_customer_template: true
    }
  },
  components: {
    'v-select': vSelect,
  },
  computed:{
    ticketList(){
        console.log(this.$store.getters["goPos/ticketList"]);
      return this.$store.getters["goPos/ticketList"];
    },
    // blockList(){
    //     console.log(this.$store.getters["goPos/blockList"]);
    //   return this.$store.getters["goPos/blockList"];
    // }
  },
  watch:{
    popupAddActive:{
      immediate: true,
        deep: true,
        handler() {
          this.select = {subject:'business_name', name: 'Business Name'};
          this.content = '';
          if(this.popupAddActive) {
            document.body.classList.add('overflow-hidden');
          } else {
            document.body.classList.remove('overflow-hidden');
          }
        }
    },
    popupUpdateActive: {
      immediate: true,
      deep: true,
      handler() {
        if(this.popupUpdateActive) {
          document.body.classList.add('overflow-hidden');
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      }
    },
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 2) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      }
    }
  },
  methods: {
    changeTypeData(type) {
      if(this.active_type != type) {
        this.active_type = type;
        let obj = {
          type: type
        }
        if(!this.isOpenLoading) {
          this.openLoadingInDiv();
        }
        this.action_type = "Get data";
        this.$store.dispatch("goPos/GET_TICKET_LIST", obj).then(() => {
          this.closeLoading();
        })
      }
    },
    upTicket(ticket){
      const obj = {
        id: ticket.id,
        action: 'up',
        type: this.active_type
      }
      this.action_type = 'Move';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("goPos/MOVE_SUBJECT" , obj).then(() => {
        this.closeLoading();
      }).catch((err) => {
        console.log('Error: ' + err);
        // this.closeLoading();
      })
    },
    downTicket(ticket){
      const obj = {
        id: ticket.id,
        action: 'down',
        type: this.active_type
      }
      this.action_type = 'Move';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("goPos/MOVE_SUBJECT" , obj).then(() => {
        this.closeLoading();
      }).catch((err) => {
        console.log('Error: ' + err);
        // this.closeLoading();
      })
    },
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' ticket failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' Ticket Failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    addTicket(){
      const obj = {
        subject: this.select.subject,
        content: this.content,
        type: this.active_type
      }
      this.action_type = 'Add';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("goPos/CREATE_TICKET_TEMPLATE" , obj).then(() => {
        this.popupAddActive = false;
        this.closeLoading();
        this.$vs.notify({
          title:'Success',
          text:'Add Ticket Template Success',
          color:'success',
          position:'top-right'
        })
      }).catch(() => {
        this.closeLoading();
        this.$vs.notify({
          title:'Fail',
          text:'Add Ticket Template Failed',
          color:'danger',
          position:'top-right'
        })
      })
    },
    deleteTicket(ticket){
      const obj = {
        id: ticket.id,
        type: this.active_type
      }
      this.type_action = 'Delete';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("goPos/DELETE_TICKET_TEMPLATE" , obj).then(() => {
        this.closeLoading();
        this.popupDeleteActive = false;
        this.$vs.notify({
          title:'Success',
          text:'Delete Ticket Template Success',
          color:'success',
          position:'top-right'
        })
      }).catch(() => {
        this.closeLoading();
        this.popupDeleteActive = false;
        this.$vs.notify({
          title:'Fail',
          text:'Delete Ticket Template Failed',
          color:'danger',
          position:'top-right'
        })
      })
    },
    updateTicket(ticket){
      this.key_selected++;
      this.ticket_id = ticket.id;
      this.selected.subject =  ticket.subject;
      this.selected.name = ticket.name;
      this.popupUpdateActive = true;
      this.param = ticket.content
    },
    submitUpdate(){
      const obj = {
        id : this.ticket_id,
        subject: this.selected.subject,
        content: this.param,
        type: this.active_type
      }
      this.action_type = 'Update';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("goPos/UPDATE_TICKET_TEMPLATE", obj).then(() => {
        this.popupUpdateActive = false;
        this.closeLoading();
        this.$vs.notify({
          title:'Success',
          text:'Update Ticket Template Success',
          color:'success',
          position:'top-right'
        })
      }).catch(() => {
        this.closeLoading();
        this.$vs.notify({
          title:'Fail',
          text:'Update Ticket Template Failed',
          color:'danger',
          position:'top-right'
        })
      })
    },
    changeFormText(){
      let obj = {
        type: 'pos_receipt'
      }
      this.$store.dispatch("goPos/GET_TICKET_LIST", obj).then(() => {
        this.loaded_data_num++;
        // let ticketList = this.$store.getters["goPos/ticketList"];
        // for(let i = 0; i< ticketList.length ; i++){
        //   if(ticketList[i].subject == 'custom_text'){
        //     this.customerText.push(ticketList[i])
        //   }
        // }
      })
    },
    setDefaultTemplate() {
      let data = {
        type: this.active_type
      }
      this.action_type = 'Set default';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("goPos/SET_DEFAULT_TICKET_TEMPLATE", data).then(() => {
        this.popupSetDefault = false;
        this.closeLoading();
        this.$vs.notify({
          title:'Success',
          text:'Set Default Ticket Template Success',
          color:'success',
          position:'top-right'
        })
      }).catch((err) => {
        console.log('Error: ' + err);
      })
    },
    onChange(type) {
      const data = {};
      if(type == 'pos_receipt') {
        data.key = 'config.pos.owner_receipt_active';
        data.value = this.active_owner_template ? 1 : 0;
        if(this.active_owner_template) {
          this.action_type = "Active Owner Template";
        } else {
          this.action_type = "Inactive Owner Template";
        }
      } else {
        data.key = 'config.pos.customer_receipt_active';
        data.value = this.active_customer_template ? 1 : 0;
        if(this.active_customer_template) {
          this.action_type = "Active Customer Template";
        } else {
          this.action_type = "Inactive Customer Template";
        }
      }
      // console.log(type, '.....', this.active_owner_template, this.active_customer_template);
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", data).then(() => {
        this.closeLoading();
        this.$vs.notify({
          title:'Notification',
          text: this.action_type + ' Success',
          color:'success',
          position:'top-right'})
      });
    }
  },
  async created(){
    this.changeFormText();
    // this.$store.dispatch("goPos/GET_BLOCK_LIST").then(() => {
    //   this.loaded_data_num++;
    //   let blockList = this.$store.getters["goPos/blockList"];
    //   console.log(this.$store.getters["goPos/blockList"]);
    //   for(let i = 0; i< blockList.length ; i++){
    //     this.options.push(blockList[i])
    //   }
    // });
    const owner_template_data = {
      key: 'config.pos.owner_receipt_active'
    }

    await this.$store.dispatch("appSetting/GET_KEY_STORAGE" , owner_template_data).then(() => {
      this.loaded_data_num++;
      let active_owner_template = this.$store.getters["appSetting/keyStorage"];
      this.active_owner_template = active_owner_template.value == 1 ? true : false;
    }).catch(() => {
      const owner_template_data = {
        key: 'config.pos.owner_receipt_active',
          value: 1
      }
      this.$store.dispatch("appSetting/ADD_KEY_STORAGE", owner_template_data).then(() => {
        this.loaded_data_num++;
      })
    })

    const customer_template_data = {
      key: 'config.pos.customer_receipt_active'
    }

    await this.$store.dispatch("appSetting/GET_KEY_STORAGE" , customer_template_data).then(() => {
      this.loaded_data_num++;
      let active_customer_template = this.$store.getters["appSetting/keyStorage"];
      this.active_customer_template = active_customer_template.value == 1 ? true : false;
    }).catch(() => {
      const customer_template_data = {
        key: 'config.pos.customer_receipt_active',
          value: 1
      }
      this.$store.dispatch("appSetting/ADD_KEY_STORAGE", customer_template_data).then(() => {
        this.loaded_data_num++;
      })
    })
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/_variables';
.vs__dropdown-menu{
  height: 150px;
}

#ticket-setting {
  .text-title {
    color: #626262;
  }

  .trash-icon {
    width: 15px;
    height: 18.89px; 
  }
  .ticket-type-btn {
    background: #929292 !important;
    box-shadow: none !important;
    &.active-btn {
      background: linear-gradient(118deg, rgba($primary, 1), rgba($primary, 0.7)) !important;
    }
  }
}

.active-template-checkbox {
  position: absolute; 
  top: 50%; 
  left: 20px; 
  transform: translateY(-50%);
  .vs-checkbox {
    width: 30px;
    height: 30px;
    // background: #fff;
    i {
      font-size: 2rem;
    }
  }
  .vs-checkbox-primary input:checked+.vs-checkbox {
    border: 2px solid #b4b4b4 !important;
    .vs-checkbox--check {
      background: #929292;
    }
  }
}

.active-btn + .active-template-checkbox {
  .vs-checkbox {
    width: 30px;
    height: 30px;
    background: #fff;
  }
  .vs-checkbox-primary input:checked+.vs-checkbox {
    .vs-checkbox--check {
      background: $primary;
    }
  }
}

// .delete-popup {
//   .delete-responsive, .cancel-responsive {
//     min-width: 140px !important;
//   }
//   @media (max-width: 405px) {
//     .delete-responsive {
//       margin: 0 0 15px !important;
//       width: 100%;
//     }
//     .cancel-responsive {
//       width: 100%;
//     }
//   }
// }

.update-ticket-popup, .create-block-ticket-popup {
  .save-responsive, .cancel-responsive {
    width: 140px;
  }

  label {
    font-size: 14px;
    display: inline-block;
    margin-top: 15px;
    margin-bottom: 5px;
  }

  @media (max-width: 405px) {
    .save-responsive {
      margin: 0 0 15px !important;
      width: 100%;
    }
    .cancel-responsive {
      width: 100%;
    }
  }
}

</style>
